import { Box, Button, CircularProgress } from "@mui/material";

const COLORS = {
  primary: "#0E7A6E",
  primaryDark: "#0B5F56",
  primaryLight: "#E6F5F2",
  border: "#E6ECEA",
  text: "#3A4441",
  hoverBg: "#F1F3F2",
};

const variantStyles = {
  outlined: (active) => ({
    border: "1px solid",
    borderColor: active ? COLORS.primary : COLORS.border,
    backgroundColor: active ? COLORS.primaryLight : "#fff",
    color: active ? COLORS.primaryDark : COLORS.text,
    "&:hover": {
      backgroundColor: COLORS.primaryLight,
      borderColor: COLORS.primary,
      color: COLORS.primaryDark,
    },
  }),

  contained: () => ({
    backgroundColor: COLORS.primary,
    color: "#fff",
    boxShadow: "none",
    "&:hover": { backgroundColor: COLORS.primaryDark, boxShadow: "none" },
    "&.Mui-disabled": {
      backgroundColor: COLORS.primaryLight,
      color: "#303030",
      opacity: 0.65,
    },
  }),

  text: () => ({
    color: COLORS.text,
    "&:hover": { backgroundColor: COLORS.hoverBg },
  }),
};

const ActionButton = ({
  onClick,
  count = 0,
  active = false,
  icon,
  label,
  showCount = false,
  disabled = false,
  loading = false,
  variant = "outlined", // "outlined" | "contained" | "text"
  sx,
  ...rest
}) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled || loading}
      startIcon={
        loading ? (
          <CircularProgress size={16} sx={{ color: "inherit" }} />
        ) : (
          icon
        )
      }
      sx={{
        borderRadius: 2,
        px: 1.75,
        py: 1,
        minWidth: "auto",
        whiteSpace: "nowrap",
        fontWeight: 600,
        textTransform: "none",
        ...variantStyles[variant](active),
        ...sx,
      }}
      {...rest}
    >
      {label}

      {showCount && count > 0 && (
        <Box
          component="span"
          sx={{
            ml: 0.75,
            backgroundColor: COLORS.primary,
            color: "#fff",
            fontSize: 11,
            fontWeight: 700,
            borderRadius: "20px",
            px: 0.9,
            py: 0.1,
            lineHeight: 1.5,
          }}
        >
          {count}
        </Box>
      )}
    </Button>
  );
};

export default ActionButton;
